export const getNodesFromFolder = () => {
  if (process.env.NODE_ENV !== "test") {
    // HACK: we need to pass a relative path to files that need to be
    // dynamically imported.
    // It would be much easier if we had this function in package/editor,
    // which we should do after we no longer have webpack.
    const modules = import.meta.glob(
      "../../../packages/editor/src/slate-nodes/*/index.{js,jsx}",
      { eager: true }
    )

    return Object.entries(modules).reduce((types, [path, module]) => {
      const type = path.split("/").at(-2)

      if (path.includes("tests")) return types

      return {
        ...types,
        [type]: module.default
      }
    }, {})
  } else {
    // We don't use Vite in tests yet
  }
}
